












































































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import AxAPI from '@/api';

type Group = I.AxZone;

type PageInfo = I.MealSettingPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

enum DialogKind {
  Card,
  Cash
}

class State {
  listReader: I.MealReaderDetail[];
  listMealTime: I.MealTimeData[];

  mealDate: string;
  mealDateMenu: boolean;

  empno: string;
  userName: string;

  userId: number;
  updateIndex: number;

  mealType: number;
  mealReader: number;
  mealCnt: number;

  constructor() {
    this.listReader = [];
    this.listMealTime = [];

    this.mealDate = U.formatTime(new Date().toISOString(), 'YYYY-MM-DD');
    this.mealDateMenu = false;

    this.empno = '' as never;
    this.userName = '' as never;

    this.userId = '' as never;
    this.updateIndex = '' as never;

    this.mealType = '' as never;
    this.mealReader = '' as never;
    this.mealCnt = 1;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
  currentKind!: DialogKind;
  zoneCode!: number;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  callback!: Function;

  async getPageInfo() {
    const result = await this.API.call.meal.configGet();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async CardEventSave(packet: I.PacketMealCardSave) {
    console.log('packet', packet);
    this.setLoading(true);
    const result = await this.API.call.meal.mealCardSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async makeMealCardPacket(): Promise<I.PacketMealCardSave | undefined> {
    if (!this.dataItem.state.listMealTime.length) {
      await this.showErrorModal('오류', '식수 유형이 선택되지 않았습니다');
      return;
    }

    if (!this.dataItem.state.listReader.length) {
      await this.showErrorModal('오류', '식수 리더기가 선택되지 않았습니다');
      return;
    }

    const mealDateRegex = /^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/g;
    const mealDate = this.dataItem.state.mealDate.replace(mealDateRegex, '$1$2$3');
    console.log('mealDate', mealDate);

    return {
      seqNo: 0,
      doorID: this.dataItem.state.listReader[0].doorID,
      userID: this.dataItem.state.userId,
      updateIndex: this.dataItem.state.updateIndex,
      eventTime: this.dataItem.state.mealDate,
      eventCode: 200,
      mealCode: this.dataItem.state.listMealTime[0].mealCode,
      mealCnt: this.dataItem.state.mealCnt,
      mealPrice: this.dataItem.state.listMealTime[0].mealPrice,
      eDate: mealDate,
      rEDate: mealDate,
      updateFlag: 'I'
    };
  }

  async onCardEventSave() {
    const packet = await this.makeMealCardPacket();
    if (!packet) return;

    this.setLoading(true);
    const result = await this.CardEventSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('정보', '저장 되었습니다.');
      return result;
    }
  }

  async CashEventSave(packet: I.PacketMealCashSave) {
    console.log('packet', packet);
    this.setLoading(true);
    const result = await this.API.call.meal.mealCashSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async makeMealCashPacket(): Promise<I.PacketMealCashSave | undefined> {
    if (!this.dataItem.state.listMealTime.length) {
      await this.showErrorModal('오류', '식수 유형이 선택되지 않았습니다');
      return;
    }

    if (!this.dataItem.state.listReader.length) {
      await this.showErrorModal('오류', '식수 리더기가 선택되지 않았습니다');
      return;
    }

    const mealDateRegex = /^([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/g;
    const mealDate = this.dataItem.state.mealDate.replace(mealDateRegex, '$1$2$3');
    console.log('mealDate', mealDate);

    return {
      seqNo: 0,
      doorID: this.dataItem.state.listReader[0].doorID,
      eventTime: this.dataItem.state.mealDate,
      eventCode: 200,
      mealCode: this.dataItem.state.listMealTime[0].mealCode,
      mealCnt: this.dataItem.state.mealCnt,
      mealPrice: this.dataItem.state.listMealTime[0].mealPrice,
      eDate: mealDate,
      updateFlag: 'I'
    };
  }

  async onCashEventSave() {
    const packet = await this.makeMealCashPacket();
    if (!packet) return;

    this.setLoading(true);
    const result = await this.CashEventSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('정보', '저장 되었습니다.');
      return result;
    }
  }

  async onSaveClicked() {
    if (this.currentKind === 0) {
      if (!this.dataItem.state.empno) {
        await this.showErrorModal('오류', '사원번호를 입력 해주세요.');
        return;
      } else if (this.dataItem.state.listMealTime.length !== 1) {
        await this.showErrorModal('오류', '식수 유형을 입력 해주세요.');
        return;
      } else if (this.dataItem.state.listReader.length !== 1) {
        await this.showErrorModal('오류', '식수 리더기을 입력 해주세요.');
        return;
      }
      this.onCardEventSave();
      this.callback();
    } else {
      if (this.dataItem.state.listMealTime.length !== 1) {
        await this.showErrorModal('오류', '식수 유형을 입력 해주세요.');
        return;
      } else if (this.dataItem.state.listReader.length !== 1) {
        await this.showErrorModal('오류', '식수 리더기을 입력 해주세요.');
        return;
      }
      this.onCashEventSave();
      this.callback();
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '카드',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    },
    {
      name: '현금',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[this.currentKind];
  }
}

@Component
class DialogHandler extends BaseClass {
  showReaderSelectDialog() {
    this.showCodeSelectDialog({
      title: '리더기 선택',
      param: {
        items: this.pageInfo.listMealReader.filter(x => x.zoneCode === this.zoneCode),
        selected: this.dataItem.state.listReader,
        headers: [
          { text: '이름', value: 'doorName', align: 'start' },
          { text: '코너', value: 'cornerName', align: 'start' }
        ],
        callback: async (selected: I.MealReaderDetail[]) => {
          if (this.dataItem.state.listReader === selected) return;

          this.dataItem.state.listReader = selected;
          this.dataItem.state.listMealTime = [];
        }
      },
      single: true
    });
  }

  showEmployeeSearchDialog() {
    type EmployeeSearchDialogParams = { param: I.DataParam };

    const dialogParams = new I.DialogParam<EmployeeSearchDialogParams>(
      'AxSearchMealEmployeeDialog',
      {
        param: {
          items: [],
          selected: [],
          callback: async () => {
            const selected = dialogParams.props.param.selected[0] as I.MealUserSearchData;
            if (!selected) return;
            console.log('select', selected);
            this.dataItem.state.empno = selected.empno;
            this.dataItem.state.userName = selected.name;
            this.dataItem.state.userId = selected.userID;
            this.dataItem.state.updateIndex = selected.updateIndex;
          }
        }
      }
    );
    this.showDialog(dialogParams);
  }

  showMealTypeSelectDialog() {
    if (!this.dataItem.state.listReader.length) return;
    const mealReader = this.dataItem.state.listReader[0];

    this.showCodeSelectDialog({
      title: '식수 유형 선택',
      param: {
        items: mealReader.listMealTime.filter(x => x.mealUse),
        selected: this.dataItem.state.listMealTime,
        headers: [
          { text: '이름', value: 'mealName', align: 'start' },
          { text: '시작', value: 'mealFromTime', align: 'start' },
          { text: '종료', value: 'mealToTime', align: 'start' },
          { text: '가격', value: 'mealPrice', align: 'start' }
        ],
        callback: async (selected: I.MealTimeData[]) => {
          this.dataItem.state.listMealTime = selected;
        }
      },
      single: true,
      itemKey: 'mealCode'
    });
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  on = true;
  width = 820;
  height = 390;

  pageInfo = {} as I.MealSettingPageInfo;

  @Prop({ type: Number, default: 0 })
  currentKind!: number;

  @Prop({ type: Number, default: 0 })
  zoneCode!: number;

  @Prop({ type: Function, default: () => {} })
  callback!: Function;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  get selectReaderText() {
    if (this.dataItem.state.listReader.length !== 1) return '';
    return `${this.dataItem.state.listReader[0].doorName} (${this.dataItem.state.listReader[0].cornerName})`;
  }

  get selectMealTypeText() {
    if (this.dataItem.state.listMealTime.length !== 1) return '';
    return `${this.dataItem.state.listMealTime[0].mealName}`;
  }

  get mealTypePrice() {
    if (this.dataItem.state.listMealTime.length !== 1) return 0;
    return `${this.dataItem.state.listMealTime[0].mealPrice}`;
  }

  get empNoWithName() {
    if (!this.dataItem.state.userName || !this.dataItem.state.empno) return;
    return `${this.dataItem.state.userName} (${this.dataItem.state.empno})`;
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler, DialogHandler));

@Component
export default class AxMealManualNewDialog extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.zoneCode = this.getZoneList()[0]?.code || 0;
    }
  }
}
